import React from 'react';

interface ClipboardCheckmarkProps {
  className?: string;
  style?: React.CSSProperties;
}

const ClipboardCheckmark: React.FC<ClipboardCheckmarkProps> = ({ 
  className, 
  style 
}) => {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path 
        d="M8.5 3.5H5C4.44771 3.5 4 3.94771 4 4.5V21C4 21.5523 4.44771 22 5 22H19C19.5523 22 20 21.5523 20 21V4.5C20 3.94771 19.5523 3.5 19 3.5H15.5M9 13.5L11.3333 16L16 11M8.5 2H15.5V5H8.5V2Z" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ClipboardCheckmark;